import { createBrowserHistory } from 'history';
import React, { useCallback, useEffect, useRef, useState } from 'react';
import { connect } from 'react-redux';
import { Router } from 'react-router-dom';
import { bindActionCreators } from 'redux';
import 'semantic-ui-css/semantic.min.css';
import AppRoutes from './AppRoutes';
import AppFooter from './components/AppFooter';
import AppHeader from './components/AppHeader';
import { ModalTipoSimulacaoHandler } from './components/ModalTipoSimulacao';
import './config/ReactotronConfig';
import DADOS_SIM from './consts/consts';
import useSegMaisBroto from './hooks/useSegMaisBroto';
import SessionService from './session/session-service';
import { Creators as CotacaoCreators } from './store/ducks/dados-cotacao';
import { Creators as HistoricoAcessoActions } from './store/ducks/historico-acesso';
import CarregamentoApp from './views/carregamento-app';

const history = createBrowserHistory();
/** Por enquanto Token Fixo */

function sleep(time) {
    return new Promise((resolve) => {
        setTimeout(resolve, time * 100);
    });
}
function mockLoad(appLoadPercent, setAppLoadPercent, appLoadBase, timeout) {
    return setInterval(() => {
        if (appLoadPercent < appLoadBase) {
            let nextPercent = appLoadPercent + (5 + Math.random() * 10);

            nextPercent = appLoadPercent > 90 && nextPercent > 100 ? 100 : nextPercent;

            setAppLoadPercent(nextPercent <= appLoadBase ? nextPercent : appLoadPercent);
        }
    }, timeout);
}

const APP_STATE_STARTING = 'Iniciando Aplicação...';
const APP_STATE_ERROR = 'A aplicação não foi carregada de forma correta.';
const APP_STATE_FETCH_SESSION = 'Buscando Sessão...';
const APP_LOADING_COMPONENTS = 'Carregando a aplicação...';
const APP_STATE_READY = 'Aplicação Iniciada.';

function App({ setHistoricoAcesso, setPenhorRural }) {
    const [appState, setAppState] = useState(APP_STATE_STARTING);
    const [appLoadPercent, setAppLoadPercent] = useState(0);
    const [appLoadBase, setAppLoadBase] = useState(50);
    const timerRef = useRef(0);

    const fetchSession = useCallback(async () => {
        setAppLoadPercent(0);
        setAppState(APP_STATE_FETCH_SESSION);
        setAppLoadBase(40);
        try {
            await SessionService.fetchSession();
            setAppLoadPercent(40);
            setAppLoadBase(60);

            await sleep(5);

            setAppLoadPercent(50);
            setAppLoadBase(70);

            await sleep(Math.random() * 5);

            setAppState(APP_LOADING_COMPONENTS);

            setAppLoadPercent(80);

            await sleep(Math.random() * 5);

            clearInterval(timerRef.current);

            setPenhorRural();
            setAppState(APP_STATE_READY);
        } catch (e) {
            setAppState(APP_STATE_ERROR);
            throw e;
        } finally {
            setAppLoadPercent(100);
            setAppLoadBase(100);
            await sleep(5);
        }
    }, []);

    // Efeito do Broto
    const [checkedBoth, checkedForBroto] = useSegMaisBroto();
    // Verifica o Acesso ao Historico
    useEffect(() => {
        if (checkedBoth && appState === APP_STATE_READY) {
            const session = SessionService.getSession();
            const codigoAcesso = session && session[DADOS_SIM.DADOS_COTACAO.CODIGO_ACESSO];
            const chaveBroto = SessionService.getChaveBroto();
            const chaveSegMais = SessionService.getChaveSegMais();
            setHistoricoAcesso(codigoAcesso, chaveSegMais, chaveBroto);
        }
    }, [checkedBoth, appState, setHistoricoAcesso]);

    useEffect(() => {
        async function fetch() {
            await fetchSession();
        }
        fetch();
    }, [fetchSession, setPenhorRural]);

    useEffect(() => {
        if (timerRef.current) {
            clearInterval(timerRef.current);
        }
        timerRef.current = mockLoad(appLoadPercent, setAppLoadPercent, appLoadBase, 1000);
        return () => clearInterval(timerRef.current);
    }, [appLoadPercent, appLoadBase]);

    if (appState === APP_STATE_READY) {
        return (
            <Router history={history}>
                <ModalTipoSimulacaoHandler checkedForBroto={checkedForBroto}>
                    <AppHeader />
                    <div style={{ minHeight: 'calc(100vh - 123px)' }}>
                        <AppRoutes />
                    </div>
                </ModalTipoSimulacaoHandler>
                <AppFooter />
            </Router>
        );
    } else {
        return (
            <CarregamentoApp loadPercent={appLoadPercent} error={appState === APP_STATE_ERROR} reload={fetchSession}>
                {appState}
            </CarregamentoApp>
        );
    }
}

const mapDispatchToProps = (dispatch) =>
    bindActionCreators({ ...HistoricoAcessoActions, ...CotacaoCreators }, dispatch);

export default connect(null, mapDispatchToProps)(App);
